import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
    //TALVEZ PRECISE DE SELECTOR    
    template: `
        <h3 mat-dialog-tile style="margin: 0px 0 20px 0;">Tipo de Ação: 
            Payload
        </h3>

        <br />

        <div mat-dialog-content>
            <div class="json-box">
                <pre>{{ payload }}</pre>
            </div>
        </div>

        <br />

        <div mat-dialog-actions align="end">
            <button mat-button class="btn-danger-new" (click)="closeModal()">Fechar</button>
        </div>
    `,
    styles: [`
        .json-box {
            background-color: #0f172a;
            color: #e5e7eb;
            border-radius: 6px;
            padding: 16px;
            max-height: 400px;
            overflow: auto;
            font-family: 'Courier New', monospace;
            font-size: 13px;
            line-height: 1.5;
        }

        pre {
            margin: 0;
            white-space: pre;
            word-break: normal;
        }

        .btn-danger-new{
            width: 100px;
            color: #fff;
            background-color: #b60000;
            border: 1px solid #b60000;
            height: 35px;
            cursor: pointer;
        }
    `]
})
export class CommunicareScheduleWebhookModalComponent implements OnInit {
    payload: string = '';
    
    constructor(
        public dialogRef: MatDialogRef<CommunicareScheduleWebhookModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ){}

    ngOnInit(): void {
        this.payload = JSON.stringify(this.data.payload, null, 2);
    }

    closeModal(){
        this.dialogRef.close();
    }
}